import { mapActions, mapGetters, mapMutations } from 'vuex'
import ClientType from '@/helper/ClientType'
import {
  PLAN_BASKET
} from '@/helper/ClientPlans'
import DefaultBaskets from '@/helper/DefaultBaskets'
import Const from '@/helper/const'
import { cloneDeep } from 'lodash'
import * as fnandoCpf from '@fnando/cpf'
import * as fnandoCnpj from '@fnando/cnpj'
import * as UserType from '@/helper/UserType'

export default {
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      userType: UserType,
      rules: {
        cpfOrCnpj: (value) => this.validatorCpfOrCnpj(value) || 'Insira um valor válido e tente novamente',
        name: (val) => val !== '' || 'Nome obrigatório',
        email: (val) => val !== '' || 'E-mail obrigatório',
        password: (val) => val !== '' || 'Senha obrigatória',
        limit: (val) => this.validateLimit(val) || 'Limite obrigatório'
      },
      listBaskets: DefaultBaskets,
      basketsToCreate: [],
      e1: true,
      name: '',
      phone: '',
      closingDayInvoice: 21,
      password: '',
      dialog: false,
      limit: 0,
      newLimit: 0,
      quizCost: 0,
      treeExplosionCost: 0,
      email: '',
      credit: '',
      idUserType: '',
      isLoading: false,
      isLoadingProductPlans: false,
      clientType: ClientType,
      selectedClientUser: '',
      selectedBasketPlans: '',
      selectedQuizPlans: '',
      selectedTreePlans: '',
      selectedPlanType: null,
      observation: null,
      cnpj: '',
      typeClient: [
        {
          name: 'Pré Pago',
          id: 'pre'
        },
        {
          name: 'Pós Controle',
          id: 'pos_controle'
        },
        {
          name: 'Pós Pago',
          id: 'pos_pago'
        }
      ],
      planTypes: []
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterSelectedClient',
      'getterAllClientUsersCommercial',
      'getterAllProductPlans',
      'getterPlanType'
    ]),
    options () {
      return {
        loading: this.isLoading
      }
    },
    filterClientPlans () {
      const basketPlans = cloneDeep(this.selectedBasketPlans) || ''

      const result = [
        basketPlans
      ]

      return result.filter((item) => item !== '').map((item) => ({ idPlan: item }))
    },
    filteredBasketPlans () {
      const list = this.getterAllProductPlans.find((item) => item.name === PLAN_BASKET)

      return list && list.plans ? list.plans.map((item) => ({ ...item, customText: `Nome: ${item.name || 'Desconhecido'} - Quantidade: ${item.value || 0} - Valor: ${item.amount || 'Não informado'}` })) : []
    },
    isDisabled () {
      let result = false
      let condition = ((this.idUserType === ClientType.CLIENT_POS_CTRL && this.idUserType !== '') && (this.filterClientPlans && this.filterClientPlans.length === 0)) || this.name === '' || !this.validatorCpfOrCnpj() || this.email === ''

      if (!this.isEditingClient) {
        condition = condition || this.password === '' || (this.selectedClientUser === '' || this.selectedClientUser === null || this.selectedClientUser === '00000000-0000-0000-0000-000000000000')
      }

      if ((this.selectedQuizPlans && this.selectedQuizPlans !== '') && (this.idUserType === ClientType.CLIENT_POS_CTRL)) {
        condition = condition || !this.formatedValue(this.quizCost)
      }

      if ((this.selectedTreePlans && this.selectedTreePlans !== '') && (this.idUserType !== ClientType.CLIENT_PRE)) {
        condition = condition || !this.formatedValue(this.treeExplosionCost)
      }

      if (this.idUserType !== '') {
        if (this.idUserType === ClientType.CLIENT_PRE) {
          result = condition
        } else {
          const conditionPos = condition || (this.closingDayInvoice < 1 || this.closingDayInvoice > 28)

          if (this.idUserType === ClientType.CLIENT_POS_CTRL) {
            result = conditionPos || this.limit === ''
          } else {
            result = conditionPos
          }
        }
      } else {
        result = true
      }

      return result
    },
    isEditingClient () {
      return Object.keys(this.getterSelectedClient).length > 0
    }
  },
  watch: {
    idUserType (val) {
      if (val && val !== '' && val !== ClientType.CLIENT_PRE) {
        this.getAllProductPlans()
      }
    }
  },
  mounted () {
    this.planTypes = this.getterPlanType
    this.setClientInfo()

    this.getAllClientUsersCommercial()

    this.getAllPlanTypes()
  },
  beforeDestroy () {
    this.SET_SELECTED_CLIENT()
    this.CLEAR_PRODUCT_PLANS_STORE()
  },
  methods: {
    ...mapActions([
      'actionAddClient',
      'actionEditClient',
      'actionGetAllClientUsersCommercial',
      'actionGetAllProductPlans',
      'actionGetPlanTypes'
    ]),
    ...mapMutations([
      'SET_SELECTED_CLIENT',
      'CLEAR_PRODUCT_PLANS_STORE'
    ]),
    formatedValue (result) {
      if (result) {
        return parseFloat(result.toString().replace('.', '').replace(',', '.'))
      }
      return 0
    },
    resetParamsWhenPos () {
      this.limit = 0

      this.selectedBasketPlans = ''
      this.selectedQuizPlans = ''
      this.selectedTreePlans = ''
      this.quizCost = 0
      this.treeExplosionCost = 0
    },
    validatorCpfOrCnpj () {
      let message = false

      if (fnandoCpf.isValid(this.cnpj)) {
        message = true
      } else if (fnandoCnpj.isValid(this.cnpj)) {
        message = true
      }

      return message
    },
    validateLimit (val) {
      if (this.idUserType === ClientType.CLIENT_POS_CTRL) {
        return val !== ''
      }
      return true
    },
    onClickMainButton () {
      if (this.isEditingClient) {
        this.editClient()
      } else {
        this.addClient()
      }
    },
    setClientInfo () {
      if (this.isEditingClient) {
        this.name = this.getterSelectedClient.name
        this.closingDayInvoice = this.getterSelectedClient.closingDayInvoice
        this.selectedClientUser = this.getterSelectedClient.idResponsibleUser
        this.credit = this.getterSelectedClient.credit
        this.email = this.getterSelectedClient.email || ''
        this.quizCost = this.getterSelectedClient.quizCost ? this.getterSelectedClient.quizCost.toFixed(2) : 0
        this.treeExplosionCost = this.getterSelectedClient.treeExplosionCost ? this.getterSelectedClient.treeExplosionCost.toFixed(2) : 0
        this.phone = this.getterSelectedClient.phone
        this.cnpj = this.getterSelectedClient.cnpj
        this.limit = this.verifyDecimalValue()
        this.idUserType = this.getterSelectedClient.type
        this.observation = this.getterSelectedClient.observation
        this.selectedPlanType = this.getterSelectedClient.idPlanType
      }

      this.dialog = true
    },
    setSelectedPlanClient () {
      if (this.getterSelectedClient.clientPlans && this.getterSelectedClient.clientPlans.length > 0) {
        this.getterSelectedClient.clientPlans.forEach((item) => {
          const basketPlans = cloneDeep(this.filteredBasketPlans).find((childItem) => childItem.idPlan === item.idPlan)

          if (basketPlans && item.active === true) {
            this.selectedBasketPlans = basketPlans.idPlan
          }
        })
      }
    },
    getAllClientUsersCommercial () {
      this.isLoading = true

      this.actionGetAllClientUsersCommercial(Const.ID_CLIENT_COMMERCIAL())
        .then(() => {
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    getAllPlanTypes () {
      this.isLoading = true

      this.actionGetPlanTypes()
        .then(() => {
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    getAllProductPlans () {
      this.isLoadingProductPlans = true

      this.actionGetAllProductPlans()
        .then(() => {
          this.isLoadingProductPlans = false

          this.setSelectedPlanClient()
        })
        .catch(() => {
          this.isLoadingProductPlans = false

          this.sendToast({
            text: 'Ocorreu um erro ao buscar os planos do cliente, tente novamente mais tarde!',
            type: 'danger'
          })
        })
    },
    addClient () {
      if ((this.closingDayInvoice > 0 && this.closingDayInvoice <= 28) || (this.idUserType === ClientType.CLIENT_PRE && this.idUserType !== '')) {
        this.isLoading = true

        const params = {
          name: this.name,
          basketsToCreate: this.basketsToCreate,
          idResponsibleUser: this.selectedClientUser,
          closingDayInvoice: this.closingDayInvoice,
          cnpj: this.cnpj,
          email: this.email,
          phone: this.phone,
          password: this.password,
          observation: this.observation,
          limit: this.idUserType === ClientType.CLIENT_PRE || this.limit === null || this.limit === '' ? 0 : parseFloat(this.limit.replace('.', '').replace(',', '.')),
          type: this.idUserType,
          idUserLogged: this.getterAccount.idUser,
          credit: 0,
          clientPlans: this.filterClientPlans || [],
          treeExplosionCost: this.formatedValue(this.treeExplosionCost),
          quizCost: this.formatedValue(this.quizCost),
          idPlanType: this.selectedPlanType
        }

        this.actionAddClient(params)
          .then(() => {
            this.sendToast({
              text: 'Cliente cadastrado com sucesso',
              type: 'success'
            })

            this.closeModal()
          })
          .catch((err) => {
            if (err && err.status) {
              if (err.status === 400 && err.data.errorMessage === '400 - Your PlanType does not allow changing the provider values.') {
                this.sendToast({
                  text: 'Seu Plano não permite alterar os valores de provider',
                  type: 'warning'
                })
              } else if (err.status === 409 && err.data.data && err.data.data.name === 'IX_Clients_Cnpj') {
                this.sendToast({
                  text: 'Este CPF/CNPJ já consta cadastrado',
                  type: 'warning'
                })
              } else if (err.status === 400 && err.data.data && err.data.data.name === 'IX_Clients_Cnpj_Invalid') {
                this.sendToast({
                  text: 'Este CPF/CNPJ não é válido',
                  type: 'warning'
                })
              } else if (err.status === 409 && err.data.data && err.data.data.name === 'IX_Clients_Email') {
                this.sendToast({
                  text: 'Esse email já consta cadastrado',
                  type: 'warning'
                })
              } else if (err.status === 400) {
                this.sendToast({
                  text: err.data.errorMessage,
                  type: 'warning'
                })
              } else {
                this.sendToast({
                  text: 'Não é possível salvar este cliente',
                  type: 'danger'
                })
              }
            }
            this.isLoading = false
          })
      } else {
        this.sendToast({
          text: 'O dia de fechamento deve ser entre 1 e 28',
          type: 'warning'
        })
      }
    },
    editClient () {
      if ((this.closingDayInvoice > 0 && this.closingDayInvoice <= 28) || (this.idUserType === ClientType.CLIENT_PRE && this.idUserType !== '')) {
        const params = {
          ...this.getterSelectedClient,
          name: this.name,
          idResponsibleUser: this.selectedClientUser,
          email: this.email,
          phone: this.phone,
          quizCost: this.formatedValue(this.quizCost),
          treeExplosionCost: this.formatedValue(this.treeExplosionCost),
          observation: this.observation,
          closingDayInvoice: this.closingDayInvoice,
          limit: ((this.limit > 0 || typeof this.limit === 'string') ? parseFloat(this.limit.replace('.', '').replace(',', '.')) : this.limit) || 0,
          type: this.idUserType === '' ? null : this.idUserType,
          idUserLogged: this.getterAccount.idUser,
          credit: this.credit || 0,
          clientPlans: this.filterClientPlans || [],
          idPlanType: this.selectedPlanType
        }

        this.isLoading = true

        this.actionEditClient(params)
          .then(() => {
            this.closeModal()

            this.sendToast({
              text: 'Cliente editado com sucesso',
              type: 'success'
            })
          })
          .catch((error) => {
            if (error && error.status && error.data) {
              if (error.status === 409 && error.data.data && error.data.data.name) {
                switch (error.data.data.name) {
                  case 'IX_Clients_Email':
                    this.sendToast({
                      text: 'O e-mail inserido já está cadastrado!',
                      type: 'warning'
                    })
                    break
                  default:
                    this.sendToast({
                      text: 'Os dados inseridos estão com conflito',
                      type: 'warning'
                    })
                }
              }
              if (error.status === 403 && error.data.message) {
                this.sendToast({
                  text: error.data.message,
                  type: 'warning'
                })
              }
            } else {
              this.sendToast({
                text: 'Ocorreu um erro ao editar o cliente, tente novamente mais tarde!',
                type: 'danger'
              })
            }

            this.isLoading = false
          })
      } else {
        this.sendToast({
          text: 'O dia de fechamento deve ser entre 1 e 28',
          type: 'warning'
        })
      }
    },
    verifyDecimalValue () {
      if (this.getterSelectedClient.type !== this.clientType.CLIENT_PRE) {
        let valueString = this.getterSelectedClient.limit.toString()
        if (valueString === null || valueString === '') {
          valueString = '0'
        }

        if (valueString.search('.') !== -1) {
          const elst = valueString.split('.')

          if (elst.length > 1 && elst[1].length > 1) {
            valueString = valueString.replace('.', ',')
            return valueString
          } if (elst.length > 1 && elst[1].length === 1) {
            valueString = `${valueString.replace('.', ',')}0`
            return valueString
          }

          return `${valueString.replace('.', ',')}00`
        }
        return `${valueString},00`
      }
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    }
  }
}
